export default __webpack_public_path__ + "static/media/CreateBackupJobDetails-MariaDB.01df9e5c.png";